import * as React from 'react';
import { useSelector,useDispatch } from 'react-redux';

function PredictionText()
{
    const state=useSelector((state)=>state);
    const dispatch = useDispatch();
    
    return (        
    <div className='prediction-text-box'>
        
    </div>
    );
}

export default PredictionText